import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function HomeGarden() {
  const { addToCart } = useCart();

  const homeGardenProducts = [
    {
      id: 'home1',
      name: 'Smart Coffee Maker',
      price: 89,
      originalPrice: 129,
      image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Programmable coffee maker with timer'
    },
    {
      id: 'home2',
      name: 'Garden Plant Pots',
      price: 24,
      originalPrice: 35,
      image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Set of 3 ceramic plant pots for indoor plants'
    },
    {
      id: 'home3',
      name: 'Kitchen Blender',
      price: 59,
      originalPrice: 79,
      image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'High-speed blender for smoothies and soups'
    },
    {
      id: 'home4',
      name: 'LED Desk Lamp',
      price: 39,
      originalPrice: 55,
      image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Adjustable LED desk lamp with touch control'
    },
    {
      id: 'home5',
      name: 'Garden Tool Set',
      price: 45,
      originalPrice: 65,
      image: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Complete garden tool set with storage bag'
    },
    {
      id: 'home6',
      name: 'Air Purifier',
      price: 129,
      originalPrice: 179,
      image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'HEPA air purifier for clean indoor air'
    },
    {
      id: 'home7',
      name: 'Throw Pillows',
      price: 19,
      originalPrice: 29,
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Decorative throw pillows for sofa'
    },
    {
      id: 'home8',
      name: 'Wall Clock',
      price: 35,
      originalPrice: 49,
      image: 'https://images.unsplash.com/photo-1563861826100-9cb868fdbe1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Home & Garden',
      description: 'Modern wall clock with silent movement'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Home & Garden</h1>
          <p>Everything you need for your home and garden</p>
        </div>
        
        <div className="product-grid">
          {homeGardenProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                  <span className="current-price">${product.price}</span>
                  <span className="original-price">${product.originalPrice}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomeGarden; 